import DOMPurify from 'isomorphic-dompurify';
import React, { useState, useRef } from 'react';

import { getString } from '../../../../helpers/styles';

export default function CommunityNewTopicEventPopupContent({
  onClose,
  topicXuid,
  addTopicEvent,
  newTopicEventReactionPopup
}) {
  const form = useRef();
  const textInput = useRef();
  const [formIsValid, setFormIsValid] = useState(false);

  return (
    <>
      <div className="communityTopicList-new-topic-event-popup-header">
        <h4 className="communityTopicList-new-topic-event-popup-header-title">
          Jouw reactie op..
        </h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="communityTopic-event-quoted-message-wrap">
        <div
          className="communityTopic-event-quoted-message"
          dangerouslySetInnerHTML={{
            __html:
              newTopicEventReactionPopup.length > 140
                ? `${newTopicEventReactionPopup.slice(0, 140)}...`
                : newTopicEventReactionPopup
          }}
        />
      </div>

      <div className="popup-body">
        <form
          ref={form}
          className="communityTopicList-new-topic-event-popup-form"
        >
          <div className="communityTopicList-new-topic-event-text-input-wrap">
            <textarea
              ref={textInput}
              onChange={() => setFormIsValid(form.current.checkValidity())}
              required
              rows="1"
              placeholder="Begin met typen"
              className="communityTopicList-new-topic-event-text-input"
              maxLength="500"
            />
          </div>
        </form>

        <button
          onClick={() =>
            formIsValid &&
            addTopicEvent({
              variables: {
                topicXuid,
                message: `<blockquote>${newTopicEventReactionPopup.trim()}</blockquote>${DOMPurify.sanitize(
                  textInput.current.value.trim()
                )}`
              }
            }).then(() => onClose())
          }
          className={getString([
            {
              value: 'popup-button popup-button-primary',
              condition: true
            },
            {
              value: 'popup-button-disabled',
              condition: !formIsValid
            }
          ])}
        >
          Plaatsen
        </button>
      </div>
    </>
  );
}
